export default __webpack_public_path__ + "static/media/placeholder_dummy2016-cafe01-mobile-de.8151ffdc.png";